import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageTitle: {
    id: 'App.LeadManagement.PageTitle',
    defaultMessage: 'Lead Management - {propertyName}',
  },
  header: {
    id: 'App.LeadManagement.Header',
    defaultMessage: 'Lead Management',
  },
  subheader: {
    id: 'App.LeadManagement.Subheader',
    defaultMessage: '{count, number} active {count, plural, one {lead} other {leads}}',
  },
  selectPropertyPrompt: {
    id: 'App.LeadManagement.SelectPropertyPrompt',
    defaultMessage: 'Select a property to view its lead pipeline.',
  },
  funnelError: {
    id: 'App.LeadManagement.FunnelError',
    defaultMessage: "We couldn't load the pipeline. Try again.",
  },
  emptyFunnel: {
    id: 'App.LeadManagement.EmptyFunnel',
    defaultMessage: 'No active leads in the pipeline yet.',
  },
  shareColumn: {
    id: 'App.LeadManagement.ShareColumn',
    defaultMessage: 'Share',
  },
  // Parked buckets below the funnel (ENG-34128) — On Hold and Waitlist, lifted out
  // of the active flow.
  parkedHeading: {
    id: 'App.LeadManagement.ParkedHeading',
    defaultMessage: 'Parked · not in the active flow',
  },
  waitlistBucket: {
    id: 'App.LeadManagement.WaitlistBucket',
    defaultMessage: 'Waitlist',
  },
  waitlistBucketUnit: {
    id: 'App.LeadManagement.WaitlistBucketUnit',
    defaultMessage: '{count, number} {count, plural, one {applicant} other {applicants}}',
  },
  onHoldBucket: {
    id: 'App.LeadManagement.OnHoldBucket',
    defaultMessage: 'On Hold',
  },
  onHoldBucketUnit: {
    id: 'App.LeadManagement.OnHoldBucketUnit',
    defaultMessage: '{count, number} {count, plural, one {lead} other {leads}}',
  },
  // Drill-down panel
  panelPrompt: {
    id: 'App.LeadManagement.PanelPrompt',
    defaultMessage: 'Select a stage to see the leads in it.',
  },
  panelCount: {
    id: 'App.LeadManagement.PanelCount',
    defaultMessage: '{count, number} {count, plural, one {lead} other {leads}}',
  },
  panelError: {
    id: 'App.LeadManagement.PanelError',
    defaultMessage: "We couldn't load these leads. Try again.",
  },
  panelEmpty: {
    id: 'App.LeadManagement.PanelEmpty',
    defaultMessage: 'No leads in this stage.',
  },
  assignedTo: {
    id: 'App.LeadManagement.AssignedTo',
    defaultMessage: 'Assigned to',
  },
  unassigned: {
    id: 'App.LeadManagement.Unassigned',
    defaultMessage: 'Unassigned',
  },
  assignSuccessHeader: {
    id: 'App.LeadManagement.AssignSuccessHeader',
    defaultMessage: 'Lead updated',
  },
  assignSuccessBody: {
    id: 'App.LeadManagement.AssignSuccessBody',
    defaultMessage: 'Assignment saved.',
  },
  assignErrorHeader: {
    id: 'App.LeadManagement.AssignErrorHeader',
    defaultMessage: "We couldn't update the assignment. Try again.",
  },
  activitySavedHeader: {
    id: 'App.LeadManagement.ActivitySavedHeader',
    defaultMessage: 'Activity updated',
  },
  activitySavedBody: {
    id: 'App.LeadManagement.ActivitySavedBody',
    defaultMessage: 'Your changes were saved.',
  },
  activityDeletedBody: {
    id: 'App.LeadManagement.ActivityDeletedBody',
    defaultMessage: 'The activity was deleted.',
  },
  activityError: {
    id: 'App.LeadManagement.ActivityError',
    defaultMessage: "We couldn't update the activity. Try again.",
  },
  scheduledMoveIn: {
    id: 'App.LeadManagement.ScheduledMoveIn',
    defaultMessage: 'Scheduled MI',
  },
  preferredMoveIn: {
    id: 'App.LeadManagement.PreferredMoveIn',
    defaultMessage: 'Preferred MI',
  },
  unit: {
    id: 'App.LeadManagement.Unit',
    defaultMessage: 'Unit',
  },
  feesPaid: {
    id: 'App.LeadManagement.FeesPaid',
    defaultMessage: 'Fees paid',
  },
  yes: {
    id: 'App.LeadManagement.Yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'App.LeadManagement.No',
    defaultMessage: 'No',
  },
  lastActivity: {
    id: 'App.LeadManagement.LastActivity',
    defaultMessage: 'Last activity',
  },
  nextActivity: {
    id: 'App.LeadManagement.NextActivity',
    defaultMessage: 'Next activity',
  },
  noneScheduled: {
    id: 'App.LeadManagement.NoneScheduled',
    defaultMessage: 'None scheduled',
  },
  relativeDays: {
    id: 'App.LeadManagement.RelativeDays',
    defaultMessage:
      '{days, plural, =0 {Today} one {# day ago} other {# days ago}}',
  },
  call: {
    id: 'App.LeadManagement.Call',
    defaultMessage: 'Call',
  },
  email: {
    id: 'App.LeadManagement.Email',
    defaultMessage: 'Email',
  },
  showingCount: {
    id: 'App.LeadManagement.ShowingCount',
    defaultMessage: 'Showing {shown, number} of {total, number}',
  },
  loadMore: {
    id: 'App.LeadManagement.LoadMore',
    defaultMessage: 'Load more',
  },
});

export default messages;
